import React from "react";
import SearchableSelect from "src/components/custom/SearchableSelect";

const DashboardFilters = ({
  open,
  tempFilters,
  districts,
  itis,
  dateError,
  activeFilterCount,
  onClose,
  onChange,
  onApply,
  onClear,
  onDateChange,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black opacity-30"
        onClick={onClose}
      />

      {/* Drawer */}
      <div className="absolute right-0 top-0 h-full w-96 bg-white shadow-2xl flex flex-col">

        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b">
          <div>
            <h2 className="text-xl font-bold">FILTERS</h2>
            {activeFilterCount > 0 && (
              <p className="text-sm text-gray-500">
                {activeFilterCount} filter(s) applied
              </p>
            )}
          </div>
          <button onClick={onClose} className="text-lg">✕</button>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-6 space-y-4">

          {/* District */}
          <div>
            <label className="block text-sm font-medium mb-1">
              District
            </label>
            <SearchableSelect
              placeholder="Select District"
              options={[
                { label: "All Districts", value: "" },
                ...districts.map(d => ({
                  label: d.district,
                  value: d.district,
                })),
              ]}
              value={tempFilters.district}
              onChange={value =>
                onChange({ ...tempFilters, district: value, iti: "" })
              }
            />
          </div>

          {/* ITI */}
          <div>
            <label className="block text-sm font-medium mb-1">
              ITI
            </label>
            <SearchableSelect
              placeholder="Select ITI"
              options={[
                { label: "All ITIs", value: "" },
                ...itis.map(i => ({
                  label: i.iti_name,
                  value: i.id,
                })),
              ]}
              value={tempFilters.iti}
              disabled={!tempFilters.district}
              onChange={value =>
                onChange({ ...tempFilters, iti: value })
              }
            />
          </div>

          {/* Start Date */}
          <div>
            <label className="block text-sm font-medium mb-1">
              Start Date
            </label>
            <input
              type="date"
              className="w-full p-3 border rounded-lg"
              value={tempFilters.from}
              max={new Date().toISOString().split("T")[0]}
              onChange={e =>
                onDateChange("from", e.target.value)
              }
            />
          </div>

          {/* End Date */}
          <div>
            <label className="block text-sm font-medium mb-1">
              End Date
            </label>
            <input
              type="date"
              className="w-full p-3 border rounded-lg"
              min={tempFilters.from}
              value={tempFilters.to}
              onChange={e =>
                onDateChange("to", e.target.value)
              }
            />
          </div>

          {/* Error */}
          {dateError && (
            <p className="text-red-500 text-sm">
              {dateError}
            </p>
          )}
        </div>

        {/* Bottom Fixed Buttons */}
        <div className="p-4 border-t bg-white">
          <div className="flex gap-3">
            <button
              onClick={onClear}
              className="flex-1 bg-red-500 text-white py-3 rounded-lg font-semibold"
            >
              Clear
            </button>
            <button
              onClick={onApply}
              className="flex-1 bg-green-600 text-white py-3 rounded-lg font-semibold"
            >
              Apply
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default DashboardFilters;